export default {
  id: "page14",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",

  questions: [
    {
      type: "justlabel",
      label:
        "Które z poniższych produktów Pan(i) używał(a)?",
      number: "25"
    },
    {
      type: "choice_names",
      options: ["TAK", "NIE"],
      topLine: true,
      labelWidth: "is-three-fifths",
      bottomLine: true
    },
    {
      label: "Cukier z prawdziwą wanilią",
      type: "radio",
      id: "kategoria9_cukierWanilia",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Laska wanili",
      type: "radio",
      id: "kategoria9_laskaWanilii",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Szafran",
      type: "radio",
      id: "kategoria9_szafran",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Kardamon",
      type: "radio",
      id: "kategoria9_kardamon",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Cynamon",
      type: "radio",
      id: "kategoria9_cynamon",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Imbir",
      type: "radio",
      id: "kategoria9_imbir",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page14.js